import LoadingHouse from "./LoadingHouse";

## Basic Usage

<LoadingHouse />

---

## In a Loading Screen

<div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "4rem",
    backgroundColor: "#f8fafc",
    borderRadius: "8px",
  }}
>
  <LoadingHouse width={64} height={64} />
  <p style={{ marginTop: "1rem", color: "#64748b" }}>Loading your project...</p>
</div>

---

## With Custom Styling

<div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
  <LoadingHouse style={{ color: "#3b82f6" }} width={48} height={48} />
  <LoadingHouse style={{ color: "#10b981" }} width={48} height={48} />
  <LoadingHouse style={{ color: "#f59e0b" }} width={48} height={48} />
</div>
